<script setup lang="ts">
defineProps<{ link: string }>()
</script>

<template>
  <iframe
    :src="link"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowfullscreen
    class="aspect-video w-full rounded-lg"
  ></iframe>
</template>
